import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { PACKAGES, PACKAGE_ICON } from "../../data/site";
import { Reveal } from "./Reveal";

export default function PackageCards() {
  return (
    <div className="grid gap-6 lg:grid-cols-3 items-stretch">
      {PACKAGES.map((p, i) => {
        const Icon = PACKAGE_ICON[p.id];
        const popular = p.popular;
        return (
          <Reveal key={p.id} delay={i * 0.08} className="h-full">
            <div
              className={`relative flex h-full flex-col rounded-2xl border p-7 md:p-8 transition-colors ${popular ? "border-gold-500/70 bg-gradient-to-b from-gold-500/[0.10] to-transparent" : p.entry ? "border-white/25 bg-white/[0.04] hover:border-gold-500/50" : "border-white/10 bg-white/[0.03] hover:border-white/25"}`}
              data-testid={`package-${p.id}`}
            >
              {popular && <span className="absolute -top-3 left-8 rounded-full bg-gold-500 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-black">Most Popular</span>}
              {p.entry && <span className="absolute -top-3 left-8 rounded-full border border-gold-500/60 bg-black px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-gold-400">Start Here</span>}
              <div className="flex items-center gap-3">
                <span className={`grid h-11 w-11 place-items-center rounded-xl ${popular ? "bg-gold-500 text-black" : "bg-gold-500/10 text-gold-400"}`}><Icon size={20} /></span>
                <div>
                  <div className="text-xs font-bold uppercase tracking-[0.18em] text-gold-500">{p.kicker}</div>
                  <h3 className="font-display text-2xl font-bold text-white">{p.name}</h3>
                </div>
              </div>
              <div className="mt-6 flex items-end gap-2">
                <span className="font-display text-4xl font-bold text-white">{p.price}</span>
                <span className="mb-1 text-xs text-zinc-500">{p.priceNote}</span>
              </div>
              <p className="mt-3 text-sm text-zinc-400">{p.blurb}</p>
              <div className="mt-5 text-sm font-semibold text-gold-400">{p.positioning}</div>
              <ul className="mt-5 flex-1 space-y-2.5">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-zinc-200">
                    <Check size={15} className="mt-0.5 shrink-0 text-gold-500" /> {f}
                  </li>
                ))}
              </ul>
              <Link
                to={`/get-started?package=${p.id}`}
                className={`mt-7 inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold transition ${popular ? "bg-gold-500 text-black hover:bg-gold-400" : "border border-white/25 text-white hover:border-gold-500 hover:text-gold-400"}`}
                data-testid={`package-cta-${p.id}`}
              >
                {p.cta} <ArrowRight size={16} />
              </Link>
            </div>
          </Reveal>
        );
      })}
    </div>
  );
}
